/* eslint-disable camelcase */
export function convertAuthorReviews(reviews) {
  const {
    user,
    product_title: titleLink,
    product_url: link,
    creation_ts: date,
    ...props
  } = reviews;
  const { first_name, last_name, avatar } = user;
  const modified_last_name = last_name.split(" ")[0];
  const name = `${first_name} ${modified_last_name}`;

  return {
    avatar,
    name,
    date,
    link,
    titleLink,
    ...props,
  };
}
